import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { MessageBox } from 'element-ui'
import { getToken, getStorage } from '@/utils/auth'
import getPageTitle from '@/utils/get-page-title'
import { authorityControl } from './settings'
import { isInDingTalk } from '@/utils/login'

NProgress.configure({ showSpinner: false })

const whiteList = ['/login', '/auth-redirect']

function denyAccess(to, from, next) {
  MessageBox.alert('不能访问该页面', '提示', {
    confirmButtonText: '确定',
    type: 'warning',
  })
  if (from && from.matched && from.matched.length) {
    next(false)
  } else {
    next({ path: '/home', replace: true })
  }
  NProgress.done()
}

router.beforeEach(async(to, from, next) => {
  NProgress.start()

  document.title = getPageTitle(to.meta.title);

  const hasToken = getToken();
  if (hasToken) {
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else if (to.path === '/home') {
      next()
      NProgress.done()
    } else if (to.path === '/preview') {
      next()
      NProgress.done()
    } else if (to.path === '/profile') {
      next()
      NProgress.done()
    } else if (to.path === '/system/contacts') {
      next()
      NProgress.done()
    } else if (to.path === '/message' || to.path.indexOf('/message/') === 0) {
      next()
      NProgress.done()      
    } else if (to.path === '/404') {
      next()
      NProgress.done()
    } else {
      const menuList = getStorage('menuList') || [];
      if (to.matched.length == 0) {
        if(menuList.indexOf(to.path) != -1) {
          store.dispatch('user/changeMenus')
          next()
        } else {
          denyAccess(to, from, next)
          return
        }
        NProgress.done()
      } else {
        if (!authorityControl) {
          next();
          NProgress.done()
          return;
        }

        if(menuList.indexOf(to.path) != -1) {
          next();
        } else {
          denyAccess(to, from, next)
          return
        }
        NProgress.done()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      if (to.path === '/login' && isInDingTalk()) {
        next({ path: '/' })
        NProgress.done()
        return
      }
      next()
    } else if (isInDingTalk()) {
      next()
    } else {
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})
